import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {ModuleSwamp}    from "@Common/react/module-swamp/module-swamp";

import {getItemEditor} from "./get-item-editor";
import {itemModules}   from "./modules/item-modules";

export const ItemOptions = ({item, templateOptions, extraModules=undefined, next: rootNext}) => cs(
    consumeContext("company"),
    ["modules", ({company}, next) => ModuleSwamp({
        moduleFeeds: [
            ...itemModules({
                templateOptions, item,
                getDefaultMailClass: () => (
                    templateOptions.mailingClasses?.hasOwnProperty(company?.prefs?.defaultMailClass) ? (
                        company.prefs.defaultMailClass
                    ) : (
                        null
                    )
                ),
            }),
            ...extraModules??[],
        ],
        next,
    })],

    ({modules}) => rootNext({

        ...modules,

        itemEditor: getItemEditor(modules),
    })
);

